function CountDown(settings){
	this.id=settings.id;//倒计时绑定的对象
	this.timer=settings.timer||60;//倒计时多少秒,默认参数与新参数替换
	this.duringTime=settings.duringTime||null;//多少秒后执行
	this.duringEvent=settings.duringEvent||null;//多少秒后执行的事件
	this.clicking=settings.clicking||function(){};//倒计时点击时的回调函数
	this.callback=settings.callback||function(){};//倒计时完成后的回调函数
	this.normalClass=settings.normalClass||'countdown';//正常样式
	this.disabledClass=settings.disabledClass||'disabled';//禁用样式
	this.clickFont=settings.clickFont||"秒后重发";
	this.afterFont=settings.afterFont||"重新发送";
    this.path=settings.path||"/";
	this.flag=false;
	this.isfirst=true;
	this.countTime=0;
	this.cookieName="countdown";//设置cookie名字
	this.cookieTime=settings.cookieTime||1;//分钟
	this.pageFlag = settings.pageFlag;  //页面标志  防止两个页面同时出现倒计时
	if(this.pageFlag){
		this.cookieName =this.cookieName+this.pageFlag;
	}
	this.init();//初始化
}
CountDown.prototype={
	init:function(){
		//var isExist=this.isExistCookie(this.cookieName);
		//store.set(this.cookieName,2);
		var isExist = this.getCookieValue(this.cookieName);	
		if(isExist!=""&&isExist>0){
			// var val=this.getCookieValue(this.cookieName);
			// this.timer=val;
			// this.startCount();
		}
	},
	startCount:function(){
		//开始计时
		var that=this;
		if(!this.flag){
			this.countTime=that.timer;
			this.flag=true;
		}
		var o=document.getElementById(that.id);
		if (this.countTime == 0 && o !=null) {
			o.removeAttribute("disabled");         
			o.value=this.afterFont;
			o.innerHTML=this.afterFont;
			this.countTime =this.timer;
			this.callback();//倒计时完成后的回调函数
			o.className=this.normalClass;
            //store.set(this.cookieName,0);
            this.setCookie(0);
		}
		else {
			if(this.isfirst){
				this.clicking();//倒计时点击时的回调函数
				o.className=this.disabledClass;
			}
			if(this.duringTime!=null){
				if(this.duringTime==this.countTime&&this.duringFlag==undefined){
					if(typeof this.duringEvent=="function"){
						this.duringFlag=true;
						this.duringEvent();	
					}
				}
			}
			this.isfirst=false;
			if(o!=null && o.setAttribute ){
                o.setAttribute("disabled", true);
			}
			// o.value=this.countTime+this.clickFont;
			if(o!=null){
                o.innerHTML=this.countTime+this.clickFont;
			} else {
                this.clearTimeId();
			}
			this.countTime--;
			this.setCookie(this.countTime);
			//store.set(this.cookieName,this.countTime);
			if(this.countTime==0){
                //store.set
                this.setCookie(0);
			}
			this.timeId=setTimeout(function(){that.startCount()},1000);
		}
	},
	clearTimeId:function(){
		clearTimeout(this.timeId);
		this.clearCookie();
	},
	setCookie:function(num){
		if(window.sessionStorage){
			window.sessionStorage.setItem(this.cookieName,num)
		}else{
			var time=new Date();
			time.setMinutes(time.getMinutes()+this.cookieTime);
			document.cookie=this.cookieName+"="+num+";path="+this.path+";expires="+time.toUTCString();
		}
		var cookieValue=this.getCookieValue(this.cookieName);
		if(cookieValue==0){
			this.clearCookie();
		}
	},
	isExistCookie:function(name){
		return document.cookie.indexOf(name)==-1?false:true;
	},
	getCookieValue:function(name){
		if(window.sessionStorage){
			var num = window.sessionStorage.getItem(this.cookieName);
			if(num!=undefined && num!=null){
				return num;
			}else{
				return "";
			}
		}else{
			var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
		    if(arr=document.cookie.match(reg))
		        return unescape(arr[2]); //返回cookie值
		    else 
		        return ""; 
		}
	  	
	},
	clearCookie:function(){
        this.isfirst=true;
		if(window.sessionStorage){
			window.sessionStorage.removeItem(this.cookieName);
		}else{
			if(this.isExistCookie(this.cookieName)){
				var exp = new Date();  
	    		exp.setTime(exp.getTime()- 100000);
				document.cookie=this.cookieName+"="+this.getCookieValue(this.cookieName)+";path="+this.path+";expires="+exp.toGMTString();
			}
		}
	}
}

export default CountDown;



// WEBPACK FOOTER //
// ./src/assets/js/common/countdown.js